// Non-marketing routes carry a robots noindex,nofollow so Google stops
// surfacing Login/portal pages in results/sitelinks. Centralized here (App.js
// renders the meta from this set) so every /portal/* path — auth, customer,
// employee, and any future one — is covered without editing each page.
// Marketing pages aren't in this set, so they stay indexable and set their own
// canonical via <Seo>. /register is deliberately NOT here: it is the fall CTA
// page, re-linked site-wide on 2026-08-08, and a stale noindex on it was
// removed on 2026-08-18 (e586c52) — do not add it back.
//
// Expects an already-normalized pathname (trailing slash stripped — see
// normalizePathname); App.js normalizes once and every path test reads that.
export const isNoindexPath = (pathname) =>
	pathname.startsWith('/portal') ||
	pathname === '/employee/login' ||
	pathname === '/customer/login' ||
	// (/trial sat here until the page was deleted on 2026-09-03; a route
	// that no longer exists needs no noindex.)
	// /change-time is a token-keyed family form (2026-09-16): nothing to index.
	// /stage is the lesson's second-screen window (2026-09-28): staff-only.
	// /lyrics-window is the lesson's lyrics column detached (2026-10-05): same.
	// /reminders/stop is a lesson reminder's token-keyed stop link (2026-10-14).
	['/login', '/sign-up', '/requests', '/change-time', '/stage', '/lyrics-window', '/reminders/stop'].includes(pathname) ||
	// /t/<storage path> is a family's track link from an email (2026-10-05):
	// one student's audition cut, nothing to index. (/testimonials must stay
	// indexable, hence the slash.)
	pathname === '/t' ||
	pathname.startsWith('/t/');
